import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledTopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 24px;
  height: 32px;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;
export const StyledTopWrapperWithdraw = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

`

export const StyledCardSide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.medium')};
  box-shadow: ${themeGet('shadows.card')};

  .custom-tooltip {
    position: absolute;
    top: 0;
  }

  &.cs-left {
    .custom-tooltip {
      position: absolute;
      left: -26px;
    }
  }

  &.cs-right {
    .custom-tooltip {
      position: absolute;
      right: -26px;
    }
  }
`;

export const StyledBalanceText = styled.h6`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.secondary.extra')};

  svg {
    margin-right: 7px;
  }
`;

export const StyledBalanceMount = styled.p`
  font-size: 25px;
  text-align: center;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.secondary.regular')};
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 38%;
`;

export const StyledLeftMount = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #F5841F;
    margin-left: 28px;
    text-transform: capitalize;
`;

export const StyledWrapper = styled.div`
  flex-grow: 1;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const StyledFlexGrow = styled.div`
  flex-grow: 1;
`;
export const  StyledFWrapBlock = styled.div`
    display: flex;
    justify-content: space-between;
`

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center; ;
`;
export const StyledWithdrawalWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
`;
export const StyledWithdrawalBlock = styled.div`
    display: flex;
    flex-direction:  column; ;
`;
export const StyledBtnWithdrawal = styled.div`
  padding: 9px 0;
    font-size: 16px;
    font-weight: 500;
    border: 1px #D5D9E7 solid;
    color:#D5D9E7;
    max-width: 85px ;
    width: 85px;
    justify-content: center;
    display: flex;
    line-height: 18px;
    cursor: pointer;
    transition: 0.3s;
    position: relative;
    &:first-of-type{
        border-bottom-left-radius:5px;
        border-top-left-radius:5px;
    }
    &:last-of-type{
        border-bottom-right-radius:5px;
        border-top-right-radius:5px;
    }
    &:hover{
        background: #D5D9E7;
        color:#4D4D4C;
    }

`;

export const StyledBtnWithdrawalBlock = styled.div`
  display: flex;
  justify-content: center; ;
`;
export const  StyledSpan  = styled.div`
    width: 85px;
    height: 38px;
`;

export const StyledTitleWithdrawal = styled.div`
  font-size: 8px;
    margin-bottom: 2px;
    color: ${themeGet('colors.primary.text')}
`;

export const  StyledWrapBtn  = styled.div`
    width: 146px;
    height: 38px;
`;
export const  StyledWrapperCheckbox  = styled.div`
   margin-bottom: 4px;
`;
